import { render, staticRenderFns } from "./ThresholdHeader.vue?vue&type=template&id=ab51996a&scoped=true"
import script from "./ThresholdHeader.vue?vue&type=script&lang=js"
export * from "./ThresholdHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab51996a",
  null
  
)

export default component.exports